<template>
    <el-dialog title="Modifier la taille" v-loading="loader" :visible.sync="display" width="50%">
        <span>Changer la taille des variations pour {{ items_selected }} produits selectionnés</span>
        <el-form class="row" ref="form" :model="form">
            <el-form-item  prop="sizes" label="Taille d'origine à remplacer" class='col'>
                <el-select
                    class="full-width"
                    clearable
                    filterable
                    v-model="form.size_origin"
                >
                    <el-option
                        v-for="item in sizesAvailable"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id"
                    />
                </el-select>
                <p class='form-text small text-secondary'>La taille qu'on souhaite remplacer</p>
            </el-form-item>

            <el-form-item  prop="sizes" label="Taille à appliquer" class='col'>
                <el-select
                    class="full-width"
                    clearable
                    filterable
                    v-model="form.size_target"
                >
                    <el-option
                        v-for="item in sizesAvailable"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id"
                    />
                </el-select>
                <p class='form-text small text-secondary'>La taille à appliquer aux variations</p>
            </el-form-item>
        </el-form>
        <p v-show='form.size_origin && form.size_target'>Les variations <strong>{{ size_origin_name }}</strong> seront remplacées par <strong>{{ size_target_name }}</strong>.</p>
        <span slot="footer" class="dialog-footer">
            <div class="switch-footer">
                <el-switch active-text="Syncronisé ?" v-model="form.sync" ></el-switch>
            </div>

            <div>
                <el-button @click="display = false">Annuler</el-button>
                <el-button type="primary" @click="action">Enregistrer</el-button>
            </div>

        </span>
    </el-dialog>
</template>
<script>
import { filterCascader } from '../../filters';
import { array_dot, array_get } from '../../../utils/array';
import findParentsInArray from '../../../utils/findParentsInArray';
export default {
    data() {
        return {
            sizesAvailable: [],
            display: false,
            loader: false,
            form: {
                size_origin: null,
                size_target: null,
                sync: false,
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        size_target_name() {
            if (!this.form.size_target) {
                return ''
            }

            return this.sizesAvailable.find(v => v.id == this.form.size_target).value
        },
        size_origin_name() {
            if (!this.form.size_origin) {
                return ''
            }

            return this.sizesAvailable.find(v => v.id == this.form.size_origin).value
        },
    },
    mounted() {
        this.loader = true;

        axios.get('/variations/1/values?orderBy=value&order=asc&limit=500').then(r => {
            this.sizesAvailable = r.data.data;
        }).then(()=>{
            this.loader = false
        });
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            this.$confirm("Remplacer les tailles ?", 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {

                    let products = this.selected.map(v => v.id);

                    // this.loader = true;
                    var datas = {
                        products,
                        mode: 'change_size',
                        size_origin: this.form.size_origin,
                        size_target: this.form.size_target,
                        sync: this.form.sync,
                    };

                    datas.total_item = this.total_item
                    datas.items_selected = this.items_selected

                    console.log({datas});
                    axios
                        .post('/products/bulk', datas)
                        .then(r => {
                            this.$emit('saved', r);
                            this.$refs.form.resetFields();
                            this.form.size_origin = null;
                            this.form.size_target = null;
                            this.form.sync = false;
                            this.display = false;
                        })
                        .catch(() => {})
                        .then(() => {
                            this.loader = false;
                        });
                })

        },
        findCategory(categoryId) {
            var categoriesOptions = this.categoriesOptions.slice(0);
            var ar = array_dot(categoriesOptions);
            var category = null;
            for (var key in ar) {
                if (key.match(/\.id$/) && ar[key] == categoryId) {
                    category = array_get(
                        categoriesOptions,
                        key.replace(/\.id$/, '')
                    );
                }
            }
            return category;
        },
        addTagCategory() {
            if (!this.form.category_secondary.length) {
                return;
            }

            var categoryId = this.form.category_secondary[
            this.form.category_secondary.length - 1
                ];
            var category = Object.assign({}, this.findCategory(categoryId));
            var index = this.form.categories_secondary.findIndex(
                v => v.id == category.id
            );

            if (index == -1) {
                this.form.categories_secondary.push(category);
            }
            this.form.category_secondary = [];
        },
        removeTagCategory(category) {
            var index = this.form.categories_secondary.findIndex(
                v => (v.id = category.id)
            );
            this.form.categories_secondary.splice(index, 1);
        },
        filterCascader(node, keyword)
        {
            return filterCascader(node, keyword)
        }
    }
};
</script>
<style lang="scss">
.switch-footer {
    text-align: left;
    margin-bottom: 10px;
}
.form-text {
    line-height: 1.1;
}
</style>
